import { render, staticRenderFns } from "./ExpansionHeader.vue?vue&type=template&id=06298983&scoped=true"
import script from "./ExpansionHeader.vue?vue&type=script&lang=js"
export * from "./ExpansionHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06298983",
  null
  
)

export default component.exports